import { render, staticRenderFns } from "./listaMovimientoPrefacturas.vue?vue&type=template&id=fec3df86"
import script from "./listaMovimientoPrefacturas.vue?vue&type=script&lang=js"
export * from "./listaMovimientoPrefacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports